import { render, staticRenderFns } from "./CompactList.vue?vue&type=template&id=4d906d78&scoped=true"
import script from "./CompactList.vue?vue&type=script&lang=js"
export * from "./CompactList.vue?vue&type=script&lang=js"
import style0 from "./CompactList.vue?vue&type=style&index=0&id=4d906d78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d906d78",
  null
  
)

export default component.exports